import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'Pourquoi 0to1 ?' },
    { path: '/testimonials', label: 'Témoignages' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-2 group"
            data-testid="navbar-logo"
            onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_prospection-pro/artifacts/uhkpo8js_logo_0to1_V1.png" 
              alt="0to1 Logo" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-[#10B981]'
                    : 'text-[#1E3A5F] font-semibold hover:text-[#1A1A1A]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="navbar-cta"
              className="bg-[#10B981] text-white font-semibold rounded-full px-6 py-2.5 hover:bg-[#0D6B5E] transition-all duration-200"
            >
              Me contacter
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#1A1A1A] p-2"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-6 border-t border-gray-100" data-testid="mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.path.replace('/', '') || 'home'}`}
                  className={`text-base font-medium transition-colors duration-200 py-2 ${
                    isActive(link.path)
                      ? 'text-[#10B981]'
                      : 'text-[#1E3A5F] font-semibold hover:text-[#1A1A1A]'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                data-testid="mobile-navbar-cta"
                className="bg-[#10B981] text-white font-semibold rounded-full px-6 py-3 text-center hover:bg-[#0D6B5E] transition-all duration-200 mt-4"
              >
                Me contacter
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
